import styled from 'styled-components'
import NextBackground from '../../assets/redemac/boas_vindas.jpg'

export const AppContainer = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const AppContainerImage = styled.div`
  background-color: white;
  min-height: 100%;
  width: 100%;
  background-image: url(${NextBackground});
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AppContainerVideo = styled.div<{ image: string }>`
  background-color: #f2f2f2;
  position: relative;
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start; /* Alinhar o vídeo no topo */
  justify-content: center;
  background-image: url(${(props) => props.image});

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50%; /* Ajuste a altura desejada aqui, por exemplo, 50% para ocupar metade da tela verticalmente */
    object-fit: cover;
  }
`;
